import { State } from '../state';

export const SiganlRConnectionSelectors = {
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    signalrConnectionData: (state: State) => state.SignalRConnection.data,
};
